module.exports = __webpack_public_path__ + "static/img/background.467d7ddc.svg";